export default function numberToColor(n) {
    return "#".concat(n.toString(16).padStart(6, "0"));
}
//# sourceMappingURL=numberToColor.js.map